export default __webpack_public_path__ + "static/media/vintage45g-1.07f7ecd8.jpg";